import React from "react";
import "./nexi-ui.css";

/**
 * NexiOrb - Signature animated energy orb representing AI presence
 * States: idle, thinking, generating, success, error, searching, file_analysis, complete
 * Sizes: sm, large (default)
 */
export default function NexiOrb({ state = "idle", size = "large" }) {
  return (
    <div 
      className={`nexi-orb nexi-orb--${state} nexi-orb--${size}`}
      data-testid={`nexi-orb-${state}`}
    >
      <div className="nexi-orb__glow" />
      <div className="nexi-orb__ring nexi-orb__ring--one" />
      <div className="nexi-orb__ring nexi-orb__ring--two" />
      <div className="nexi-orb__core">
        <span>N</span>
      </div>
    </div>
  );
}
